/*
  Gift wrapping controls — Aroma Garden
  Loaded as a theme asset (not inline in snippets/gift-wrapping.liquid) because
  Dawn re-renders the cart drawer with the Section Rendering API via innerHTML,
  and <script> tags injected that way never execute. Listeners are delegated on
  document, so the controls work whenever the markup appears.

  2026-08-07 QUANTITY FIX. Ticking the box used to call /cart/add.js, which
  INCREMENTS rather than sets. The checkbox in gift-wrapping.liquid renders
  checked whenever the variant is in the cart at ANY quantity, so a second add
  silently stacked the line to 2+ and overcharged the customer with no visible
  cue. Three changes: adding is now idempotent, carts already stuck above 1 are
  repaired on load, and the gift-wrap line's quantity stepper is locked.
*/
(function () {
  if (window.__aggwInit) return;
  window.__aggwInit = true;

  function panel() {
    return document.querySelector('[data-aggw]');
  }

  function variantId() {
    var w = panel();
    return w ? w.getAttribute('data-aggw-variant') : null;
  }

  function busy(on) {
    document.querySelectorAll('[data-aggw]').forEach(function (w) {
      if (on) { w.classList.add('is-busy'); } else { w.classList.remove('is-busy'); }
      var s = w.querySelector('[data-aggw-status]');
      if (s) s.hidden = !on;
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function lineFor(cart, id) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(id)) return items[i];
    }
    return null;
  }

  function setQty(id, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: qty })
    });
  }

  function addOne(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    });
  }

  /* ---- checkbox: add / remove gift wrapping, never stacking above 1 ---- */
  document.addEventListener('change', function (e) {
    var box = e.target && e.target.closest ? e.target.closest('[data-aggw-check]') : null;
    if (!box) return;
    var wrap = box.closest('[data-aggw]');
    var id = wrap ? wrap.getAttribute('data-aggw-variant') : null;
    if (!id) return;
    busy(true);

    var req;
    if (box.checked) {
      req = getCart().then(function (cart) {
        return lineFor(cart, id) ? setQty(id, 1) : addOne(id);
      });
    } else {
      req = setQty(id, 0);
    }

    req.then(function () {
      window.location.reload();
    }).catch(function () {
      busy(false);
      box.checked = !box.checked;
    });
  });

  /* ---- gift message: debounced autosave to a cart attribute ---- */
  var timer;
  document.addEventListener('input', function (e) {
    var field = e.target && e.target.closest ? e.target.closest('[data-aggw-input]') : null;
    if (!field) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Gift message': field.value } })
      }).catch(function () {});
      var wrap = field.closest('[data-aggw]');
      var note = wrap ? wrap.querySelector('[data-aggw-saved]') : null;
      if (note) {
        note.hidden = false;
        setTimeout(function () { note.hidden = true; }, 1600);
      }
      document.querySelectorAll('[data-aggw-input]').forEach(function (other) {
        if (other !== field) other.value = field.value;
      });
    }, 600);
  });

  /* ---- lock the gift-wrap line's quantity stepper ---- */
  function lockStepper() {
    var id = variantId();
    if (!id) return;
    document
      .querySelectorAll('.quantity__input[data-quantity-variant-id="' + id + '"]')
      .forEach(function (input) {
        var qi = input.closest('quantity-input');
        if (!qi || qi.hasAttribute('data-aggw-locked')) return;
        qi.setAttribute('data-aggw-locked', '');
        input.readOnly = true;
        input.setAttribute('aria-readonly', 'true');
        qi.querySelectorAll('.quantity__button').forEach(function (b) {
          b.disabled = true;
          b.style.display = 'none';
        });
      });
  }

  /* ---- repair a cart that stacked before this fix shipped ---- */
  function flag(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (err) {
      return null;
    }
  }

  function repair() {
    var id = variantId();
    if (!id) return;
    if (flag('aggwRepaired') === '1') return;
    getCart().then(function (cart) {
      var line = lineFor(cart, id);
      if (line && line.quantity > 1) {
        flag('aggwRepaired', '1');
        setQty(id, 1).then(function () {
          window.location.reload();
        });
      }
    }).catch(function () {});
  }

  function start() {
    lockStepper();
    repair();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Dawn re-renders the cart and drawer via the Section Rendering API, which
     replaces the markup — re-apply the stepper lock whenever that happens. */
  var reapply;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      clearTimeout(reapply);
      reapply = setTimeout(lockStepper, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
